import React, { useEffect, useState } from 'react';
import '../../css/methods/Lesson.css';

import Image from 'react-image-webp';

import image1 from '../../images/study-method/class1.jpeg';
import imageWebp1 from '../../images/study-method/class1.webp';

import image2 from '../../images/study-method/class2.jpeg';
import imageWebp2 from '../../images/study-method/class2.webp';

import { IoBulbOutline, IoPaperPlaneOutline, IoCogOutline, IoSchoolOutline } from 'react-icons/io5';
import { AiFillQuestionCircle } from 'react-icons/ai';

import { useDispatch } from 'react-redux';

import { openTrainingMore } from '../../features/training';

const Lesson = () => {
	const [active, setActive] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		setTimeout(() => {
			setActive(true);
		}, 100);
	}, [active]);

	return (
		<div className='Description' style={active ? { opacity: 1 } : { opacity: 0 }}>
			<div className='description-content'>
				<div className='description-content-header'>
					<h2 className='description-content-title'>
						Clases en vídeo con feedback en vivo y en Discord
					</h2>
					<div className='description-content-separator'></div>
				</div>
				<p>
					Tendrás a tu disposición entrenamientos de nivel básico para que puedas adaptarte a un
					flujo de trabajo responsable para luego asumir el gran reto de crear personajes para
					videojuegos, donde tendrás:
				</p>
				<ul>
					<li>
						<IoBulbOutline className='description-icon' />
						Acompañamiento online en vivo por semana para ver tus avances y aclarar dudas.
					</li>
					<li>
						<IoPaperPlaneOutline className='description-icon' />
						Acceso a un grupo de Discord privado.
						<AiFillQuestionCircle
							className='description-question'
							onClick={() => {
								dispatch(
									openTrainingMore({
										modal: true,
										title: 'Discord Privado',
										more: 'Discord es una plataforma de interacción donde estarás en contacto con tus compañeros y el maestro. Podrás hacer preguntas y subir tus avances.',
									})
								);
							}}
						/>
					</li>
					<li>
						<IoCogOutline className='description-icon' />
						Plataforma de cursos para ver las clases en vídeo.
					</li>
					<li>
						<IoSchoolOutline className='description-icon' />
						Acceso al contenido por un año.
					</li>
				</ul>

				<a
					className='button-description'
					href='https://drive.google.com/file/d/1ojvO3tlLU7XCCHdh4VXPgW2LMGa27Arm/view'
					target={'_blank'}
					rel='noreferrer'
				>
					Ver Temario
				</a>
			</div>
			<div className='description-images-container'>
				<div className='description-image image-description-up'>
					<Image src={image1} webp={imageWebp1} />
				</div>
				<div className='description-image image-description-down'>
					<Image src={image2} webp={imageWebp2} />
				</div>
			</div>
		</div>
	);
};

export default Lesson;
